import "./AboutUsStyles.css";

function AboutUs() {
  return (
    <div className="about-container">
     <h1>Our History</h1>
      <p>
        Founded in 2024, Tripzky was born from a deep passion for Sri Lanka’s
        rich cultural heritage and breathtaking landscapes. What started as a
        small blog sharing travel tips and stories has grown into a
        comprehensive resource for travelers worldwide. Over the years, we have
        expanded our offerings to include detailed guides, curated itineraries,
        and insider recommendations, all aimed at helping visitors experience
        the very best of Sri Lanka. Our journey is driven by a commitment to
        authenticity, quality, and sustainability in tourism.
      </p>
      <h1>Our Mission</h1>
      <p>
        Our mission is to inspire and guide travelers from around the world to
        discover the rich cultural heritage, stunning natural landscapes, and
        warm hospitality of Sri Lanka. We aim to provide comprehensive,
        up-to-date information and resources that make planning and experiencing
        an unforgettable journey in Sri Lanka seamless and enjoyable. Through
        our platform, we strive to promote sustainable tourism that supports
        local communities and preserves the island's natural beauty for future
        generations.
      </p>
      <h1>Our Vision</h1>
      <p>
        Our vision at Tripzky is to become the leading online destination for
        Sri Lanka tourism, renowned for delivering exceptional travel
        experiences and insightful content. We aspire to connect global
        travelers with the hidden gems and iconic attractions of Sri Lanka,
        fostering a deeper appreciation for its culture, nature, and history. By
        championing sustainable and responsible tourism, we aim to contribute to
        the island’s growth and ensure that its wonders can be enjoyed by
        generations to come.
      </p>
    </div>
  );
}

export default AboutUs;
